export default "__VITE_ASSET__e6839d2a__"